import {isEmpty} from "lodash";

export const isObjectWithEmptyFields = obj =>
    isEmpty(obj) ||
    Object.values(obj).every(val => val === undefined || val === null || val === "" || val?.length === 0);
